<po-page-default p-title="Cadastro de Usuários" [p-breadcrumb]="breadcrumb">
    <p class="page-subtitle">Consulte os usuários cadastrados no sistema.</p>

    <div class="po-row actions-row">
        <div class="po-lg-8">
            <po-button class="po-mr-2" p-label="Novo Usuário" p-kind="primary" icon="po-icon-plus"
                (p-click)="openNewUserModal()"></po-button>
            <po-button p-label="Atualizar" p-kind="secondary" (p-click)="refreshData()"></po-button>
        </div>
        <po-input class="po-lg-4 search-input" p-placeholder="Buscar por nome ou e-mail..."
            [(ngModel)]="search" (ngModelChange)="applySearch()">
        </po-input>
    </div>

    <p class="po-font-subtitle">Verifique todos os usuários cadastrados no sistema.</p>
    <po-divider></po-divider>

    <div class="users-list-wrap">
        <po-loading-overlay [hidden]="deletingUserEmail === null && togglingUserEmail === null"></po-loading-overlay>
        <div class="users-list">
            <div class="users-header">
                <span>Nome</span>
                <span>E-mail</span>
                <span>Ativo</span>
                <span>Ações</span>
            </div>

            <div class="users-row" *ngFor="let row of filteredUsers" [class.user-inactive]="!row.ativo">
                <span>{{ row.nome }}</span>
                <span>{{ row.email }}</span>
                <span class="status-badge" [class.status-ativo]="row.ativo" [class.status-inativo]="!row.ativo">
                    {{ row.ativo ? 'Ativo' : 'Inativo' }}
                </span>
                <div class="user-actions">
                    <po-button
                        p-size="small"
                        p-kind="tertiary"
                        p-label="Roles"
                        p-icon="an an-note-pencil"
                        (p-click)="openRolesModal(row)">
                    </po-button>
                    <po-button
                        p-size="small"
                        [p-kind]="row.ativo ? 'secondary' : 'primary'"
                        [p-label]="row.ativo ? 'Inativar' : 'Reativar'"
                        [p-icon]="row.ativo ? 'an an-prohibit' : 'an an-check-circle'"
                        [p-disabled]="togglingUserEmail !== null || deletingUserEmail !== null"
                        [p-loading]="togglingUserEmail === row.email"
                        (p-click)="toggleUserEnabled(row)">
                    </po-button>
                    <po-button
                        p-size="small"
                        p-kind="danger"
                        p-label="Remover"
                        p-icon="an an-trash"
                        [p-disabled]="deletingUserEmail !== null || togglingUserEmail !== null"
                        [p-loading]="deletingUserEmail === row.email"
                        (p-click)="removeUser(row)">
                    </po-button>
                </div>
            </div>
        </div>
    </div>
</po-page-default>

<po-modal #newUserModal p-title="Novo Usuário" p-size="md">
    <div class="po-row">
        <po-input class="po-lg-12" p-label="Nome Completo" [(ngModel)]="newUser.nomeCompleto"
            [disabled]="creatingUser"></po-input>
        <po-email class="po-lg-12" p-label="E-mail" [(ngModel)]="newUser.email"
            [disabled]="creatingUser"></po-email>
    </div>
    <po-modal-footer>
        <po-button p-label="Cancelar" p-kind="tertiary" [p-disabled]="creatingUser"
            (p-click)="newUserModal.close()"></po-button>
        <po-button p-label="Criar Usuário" [p-loading]="creatingUser" [p-disabled]="creatingUser"
            (p-click)="createUser()"></po-button>
    </po-modal-footer>
</po-modal>

<po-modal #rolesModal p-title="Associar/Remover Roles" p-size="lg">
    <p class="po-font-text">Usuário: <b>{{ selectedUser?.nome }}</b> ({{ selectedUser?.email }})</p>
    <p class="po-font-text">Exibindo apenas as roles que o usuário já possui.</p>
    <div class="roles-toolbar" *ngIf="!rolesLoading">
        <span></span>
        <div class="roles-toolbar-actions">
            <po-button p-label="Atribuir novas roles" p-kind="primary" (p-click)="openAssignRolesModal()"></po-button>
        </div>
    </div>
    <div class="roles-list" *ngIf="!rolesLoading && roles.length > 0">
        <div class="roles-header">
            <span>Role</span>
            <span>Ações</span>
        </div>
        <div class="roles-row" *ngFor="let row of roles">
            <span class="role-name">{{ row.name }}</span>
            <div class="role-actions">
                <po-button p-size="small" p-kind="danger" p-label="Remover" p-icon="po-icon-delete"
                    (p-click)="removeRole(row)"></po-button>
            </div>
        </div>
    </div>
    <div class="roles-empty" *ngIf="!rolesLoading && roles.length === 0">
        Usuário não possui permissões.
    </div>
    <div class="roles-empty" *ngIf="rolesLoading">
        Carregando permissões...
    </div>
    <po-modal-footer>
        <po-button p-label="Fechar" p-kind="tertiary" (p-click)="rolesModal.close()"></po-button>
    </po-modal-footer>
</po-modal>

<po-modal #assignRolesModal p-title="Atribuir novas roles" p-size="lg">
    <p class="po-font-text">Usuário: <b>{{ selectedUser?.nome }}</b> ({{ selectedUser?.email }})</p>
    <p class="po-font-text assign-hint">
        Selecione as roles abaixo e clique em <b>Salvar</b> para atribuir em lote.
        O usuário será notificado por e-mail sobre os novos menus liberados.
    </p>

    <div class="pending-roles-box" *ngIf="pendingRoles.length > 0">
        <p class="pending-roles-title">Selecionadas para salvar ({{ pendingRoles.length }})</p>
        <div class="roles-list assign-roles-list pending-roles-list">
            <div class="roles-header">
                <span>Role</span>
                <span>Detalhes</span>
                <span class="roles-col-action">Ação</span>
            </div>
            <div class="roles-row" *ngFor="let row of pendingRoles">
                <span class="role-name">{{ row.name }}</span>
                <span class="role-description">{{ row.description || '—' }}</span>
                <div class="role-actions">
                    <po-button p-size="small" p-kind="tertiary" p-label="Remover" p-icon="po-icon-minus"
                        [p-disabled]="savingRoles" (p-click)="removerRolePendente(row)"></po-button>
                </div>
            </div>
        </div>
    </div>

    <p class="po-font-text po-mt-2" *ngIf="!availableRolesLoading">Roles disponíveis</p>
    <div class="roles-list assign-roles-list" *ngIf="!availableRolesLoading && availableRoles.length > 0">
        <div class="roles-header">
            <span>Role</span>
            <span>Detalhes</span>
            <span class="roles-col-action">Ação</span>
        </div>
        <div class="roles-row" *ngFor="let row of availableRoles">
            <span class="role-name">{{ row.name }}</span>
            <span class="role-description">{{ row.description || '—' }}</span>
            <div class="role-actions">
                <po-button p-size="small" p-label="Selecionar" p-icon="po-icon-plus"
                    [p-disabled]="savingRoles" (p-click)="adicionarRolePendente(row)"></po-button>
            </div>
        </div>
    </div>
    <div class="roles-empty" *ngIf="!availableRolesLoading && availableRoles.length === 0 && pendingRoles.length === 0">
        Não há roles disponíveis para adicionar.
    </div>
    <div class="roles-empty" *ngIf="!availableRolesLoading && availableRoles.length === 0 && pendingRoles.length > 0">
        Todas as roles disponíveis já foram selecionadas. Clique em Salvar para concluir.
    </div>
    <div class="roles-empty" *ngIf="availableRolesLoading">
        Carregando roles disponíveis...
    </div>
    <po-modal-footer>
        <po-button p-label="Cancelar" p-kind="tertiary" [p-disabled]="savingRoles"
            (p-click)="fecharAssignRolesModal()"></po-button>
        <po-button p-label="Salvar" p-kind="primary" p-icon="po-icon-ok"
            [p-loading]="savingRoles" [p-disabled]="savingRoles || pendingRoles.length === 0"
            (p-click)="salvarRolesPendentes()"></po-button>
    </po-modal-footer>
</po-modal>